<template>
<m-pageframe
    title="Alert Delivery Settings for {employee-label}"
>
<v-container>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.alert_type="{ item }">
            {{$rc.pretty(item.alert_type,'enum_alert_type')}}
        </template>

        <template v-slot:item.send_email="{ item }">
            <v-simple-checkbox
                v-on:input="saveItem(item)"
                v-model="item.send_email"
                :ripple="false"
            >
            </v-simple-checkbox>
        </template>

        <template v-slot:item.send_text="{ item }">
            <v-simple-checkbox
                v-on:input="saveItem(item)"
                v-model="item.send_text"
                :ripple="false"
            >
            </v-simple-checkbox>
        </template>
    
    </v-data-table>


</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            full_text: null,
            results: [],

            headers: [
                { text: 'Type', value: 'alert_type'},
                { text: 'Email', value: 'send_email'},
                { text: 'Text', value: 'send_text'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/alerts/delivery-preferences',
            
                'params' : {
                        'full_text': this.full_text,
                        'employee_id': this.$route.params.employee_id,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        saveItem(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/alert/delivery-preferences',
            
                'params' : item,
            
                'on_success': (data) => {
                        
                    },
            
                'on_error': 'Unable to update alert delivery preferences',
            });
        },
    },
}
</script>

<style lang="scss" scoped>
</style>